
define('modules/application/wizard/classes/kits',["app",

// Libs
"backbone",

//Classes
"./genericElement",

//Plugins
"plugins/jquery-dotdotdot"],

function(app, Backbone, genericElement) {

  var kitModel = Backbone.Model.extend({

      initialize                        : function() {
        var finalPackage;

        this.fetchProducts();
        this.fetchComponentsPackages();
      },

      insertThisKit                     : function(kitCode, that) {
        var value         = that.findValueFromProductCode(kitCode);
        var finalPackage, dataToReturn = {};

        if (value)
        {
          dataToReturn.packages = [value];
          that.kitsFetchedEventHandler(dataToReturn);
          that.confirmSelectedKit();
        }
      },

      fetchProducts                     : function() {
        var that           = this,
            fetchedKits    = this.get("fetchedKits"),
            packageClassId = this.get("packageClassId");

        this.trigger("products:fetching");

        if(!this.get("isPopulated")) {

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(this.get("packageClassId"), function(data) {
            var products          = data.products;
            var mainProduct       = _.filter(products,function(product)    {return (product.mnemonic===1);})[0];
            var secondaryProducts = _.filter(products,function(product)    {return (product.mnemonic!==1);});

            that.attributes = _.extend(that.attributes, mainProduct);
            that.set("secondaryProducts", secondaryProducts);

            if (products.length>0)
              that.set("isPopulated", true);
            else
              console.log("No products for the given package");
          }, false);
          this.trigger("render:requested");
        }
      },

      fetchComponentsPackages           : function(kit) {
        var that          = this,
            packages      = this.get("specialVars").packages,
            packagesLength= packages.length,
            i             = 0;

        var valorizePackage = function(currentPackage) {
          if (currentPackage.specialVars)
            currentPackage.specialVars = JSON.parse(currentPackage.specialVars);

          packages[i]                = _.extend(packages[i], currentPackage);

          if (packages[i].gotZone)
          {
            packages[i].addToZone  = 1;
            packages[i].generatedId= new Date().getUTCMilliseconds();
          }

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(packages[i].packageClassId, function(data) {
            var mainProduct       = _.filter(data.products,function(product)    {return (product.mnemonic===1);})[0];
            var secondaryProducts = _.filter(data.products,function(product)    {return (product.mnemonic!==1);});

            _.extend(packages[i], mainProduct);
            packages[i].secondaryProducts = secondaryProducts;

          }, false);
        };

        for (i = packagesLength - 1; i >= 0; i--)
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(packages[i].packageClassId, valorizePackage, false);

        that.trigger("products:fetched");
      },

      addKit                : function(_silent) {
        var added = this.get("added");
        var silent= false;

        if (_silent)
          silent = _silent;

        if (!added)
        {
          var kitPackages = this.get("specialVars") ? this.get("specialVars").packages : [];

          var zoneNumberChangedEventHandler  =  function(newZoneNumber) {
            this.addToZone = newZoneNumber;
          };

          var requestRefresh                 = function() {
            this.trigger("render:requested");
          };

          if (!silent)
            for(var i=0, packagesLength = kitPackages.length; i<packagesLength; i++)
            {
              kitPackages[i].kitsEventAggregator = _.extend({}, Backbone.Events);
              kitPackages[i].kitsEventAggregator.bind("zoneNumber:changed", zoneNumberChangedEventHandler, kitPackages[i]);
              kitPackages[i].kitsEventAggregator.bind("zoneNumber:changed", requestRefresh, this);
              window.BticinoS4B.eventAggregator.trigger(kitPackages[i].name+":addedFromKit", kitPackages[i]);
            }

          this.set("added", true);
          window.BticinoS4B.eventAggregator.trigger("kit:added");
          this.trigger("render:requested");
        }
        // else
        //   this.removeCurrentKit();

        this.trigger("render:requested");
        window.BticinoS4B.eventAggregator.trigger("kit:added");
        this.trigger("updateViews");
      },

      updatePackageZone                 : function(selector) {
        var packageNumber   = selector.attr("name").substring(13, selector.attr("name").length),
            zoneNumber      = selector.val(),
            packageToUpdate = this.get("specialVars").packages[packageNumber];

        if (this.get("added"))
        {
          this.removePackageFromZone(packageToUpdate);
          packageToUpdate.addToZone = zoneNumber;
          this.addPackageToZone(packageToUpdate);
        }
        else
          packageToUpdate.addToZone = zoneNumber;
      },

      addPackageToZone                  : function(packageToAdd) {
        packageToAdd.kitsEventAggregator = _.extend({}, Backbone.Events);
        packageToAdd.kitsEventAggregator.bind("zoneNumber:changed", function(newZoneNumber){
          packageToAdd.addToZone = newZoneNumber;
          this.trigger("render:requested");
        }, this);
        window.BticinoS4B.eventAggregator.trigger(packageToAdd.name+":addedFromKit", packageToAdd);
      },

      removePackageFromZone             : function(packageToRemove) {
        var zonePackage = packageToRemove.addToZone;
        window.BticinoS4B.eventAggregator.trigger(packageToRemove.name+":removeKitPackage", packageToRemove);
      }
  });

  var kitView  = Backbone.View.extend({
      template: "application/wizard/sections/kit/kitItem",
      className : "kitElement",
      events: {
        "click .ui-spinner-up"       : "spinnerUpEventHandler",
        "click .toggleDetailButton"  : "toggleDetailButtonClickedEventHandler",
        "click .addKit"              : "addKitButtonClickedEventHandler",
        "change .packageZoneSelector": "packageZoneSelectorChanged"
      },
      serialize: function(){return{model:this.model, app:app};},
      initialize : function() {
        this.model.bind("render:requested", this.renderRequestedEventhandler, this);
        var kitCode = BticinoS4B.Instances.Models.ApplicationModel.get("kitCode");
        if(kitCode){
        //   setTimeout(function(){that.kitModel.prototype.insertThisKit(kitCode, that);}, 1000);
            this.model.addKit(false);
            var systemId=window.BticinoS4B.Instances.Models.ApplicationModel.get("systemId");
            if(systemId=="#4")
              BticinoS4B.solution.intrusionDetection.inserted = true;
            if(systemId=="#21")
              BticinoS4B.solution.energyManagement.inserted = true;

        }
      },
      renderRequestedEventhandler           : function()  {
        this.render();
      },
      toggleDetailButtonClickedEventHandler : function(e) {
        var that        = this,
            kitDetail   = this.$el.find(".kitDetail"),
            toggleQuote = function(){
                            if (!kitDetail.is(":visible"))
                              that.$el.find("h6").text($.i18n._("IDS_WAM8_34"));
                            else
                              that.$el.find("h6").text($.i18n._("IDS_WAM8_33"));
                          };

        e.preventDefault();
        e.stopPropagation();
        toggleQuote();
        kitDetail.slideToggle({easing : "swing", duration : "slow"});

        return false;
      },

      spinnerUpEventHandler: function()
      {
        alert('spinnerUpEventHandler');
      },

      packageZoneSelectorChanged      : function(e){
        var selector = $(e.target);
        this.model.updatePackageZone(selector);
      },

      addKitButtonClickedEventHandler : function(e)
      {
        this.model.addKit(this.model.productCode);
        var systemId=window.BticinoS4B.Instances.Models.ApplicationModel.get("systemId");
        if(systemId=="#13+20")
          BticinoS4B.solution.automation.inserted=true;
        else
          if(systemId=="#4")
            BticinoS4B.solution.intrusionDetection.inserted=true;
      },

      afterRender: function() {
        this.$el.find(".kitDetail").hide();
        // window.BticinoS4B.eventAggregator.trigger("kit:added");
      }
  });

  var kits    = _.extend({}, genericElement, {

    Views: {

      titleBar: genericElement.Views.titleBar.extend({
        template: "application/wizard/sections/kit/titleBar",
        tagName:  "h3",

        initialize                      : function() {
          window.BticinoS4B.eventAggregator.bind("kit:added", this.setLabel, this);
          this.model.titleBarView = this;
          this.model.bind("render:requested", this.render, this);
        },

        setLabel                        : function() {
          var caption           =   this.$el.find(".caption"),
              stringToPrint     =   "",
              fetchedKits       =   this.model.get("fetchedKits");

          for (var i = 0, length = fetchedKits.length; i < length; i++) {
            if (fetchedKits[i].get("added"))
            {
              if (stringToPrint!=="")
                stringToPrint += " - ";

              stringToPrint += $.i18n._(fetchedKits[i].get("packageClassLabel"));
            }
          }

          if (stringToPrint!=="")
          {
            caption.html(stringToPrint);
            caption.css("color", "#a0a2a3");
            caption.fadeIn(200);
          }
          else
            if(this.titleBarView)
              this.titleBarView.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
        },

        removeLabel                     : function() {
          this.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
        },

        enable                          : function() {
          this.$el.trigger("click");
        },

        disable                         : function() {
          this.$el.trigger("click");
        },

        onClose                         : function(){
          this.model.unbind("updateViews", this.setLabel);
        },
        afterRender                     : function(){
          var kitTmp=BticinoS4B.Instances.Models.ApplicationModel.get("kitCode");
          //console.log(this);
          if(!kitTmp)
            this.$el.hide();
          else
            this.$el.show();
        }
      }),

      content: genericElement.Views.content.extend({
        template: "application/wizard/sections/kit/content",
        className: "kit",
        kitViews : [],
        events: {
          // events MHkit1114 section
          "click .customizeKeycaps"                         : "customizeKeycapsEventHandler",
          "click .goToControlDevices"                       : "goToDevicesEventHandler",
          "click .goToIntegrationDevices"                   : "goToDevicesEventHandler",
          "click .spinner-lights .ui-spinner-down"          : "spinnerEventHandler",
          "click .spinner-lights .ui-spinner-up"            : "spinnerEventHandler",
          "click .spinner-rollingShutters .ui-spinner-down" : "spinnerEventHandler",
          "click .spinner-rollingShutters .ui-spinner-up"   : "spinnerEventHandler",
          "click .spinner-commands .ui-spinner-down"        : "spinnerEventHandler",
          "click .spinner-commands .ui-spinner-up"          : "spinnerEventHandler"
        },

        showWariningText: function() {
          var nrOfActuatorsToAdd = (this.model.get('nrOfActuatorLights') - this.model.get('defaultActuatorLights')) + (this.model.get('nrOfActuatorShutters') - this.model.get('defaultActuatorShutters'));
          var nrOfCommandsToAdd  = this.model.get('nrOfCommands') - this.model.get('minNrOfCommands');
          
          if (nrOfActuatorsToAdd < 0) { nrOfActuatorsToAdd = 0; }
          var newString = '<img src="/assets/img/exclamationMark.png" alt=""/> Per completare questa soluzione verranno aggiunti al kit '+ nrOfActuatorsToAdd +' attuatori e '+ nrOfCommandsToAdd +' comando.';
          
          if (nrOfActuatorsToAdd !== 0 || nrOfCommandsToAdd !== 0)
          {
            $("p.wariningText").html(newString);
            this.$el.find(".wariningText")[0].style['visibility'] = 'visible';
          }
          else this.hideWariningText();
        },

        hideWariningText: function() {
          this.$el.find(".wariningText")[0].style['visibility'] = 'hidden';
        },

        addElementToKitEventHandler: function(){
          if (this.model.get('updateAutocalculatedElements')) {
            var nrOfLights                 = this.model.get('nrOfLights');
            var nrOfkitsActuators          = this.model.get('defaultActuatorLights') + this.model.get('defaultActuatorShutters');
            var nrOfActuatorRemnant        = nrOfkitsActuators;
            var nrOfActuatorLights         = this.model.get('nrOfActuatorLights');
            var nrOfActuatorShutters       = this.model.get('nrOfActuatorShutters');
            var requirements               = nrOfActuatorLights + nrOfActuatorShutters;
            var nrOfAvailablekitsActuators = nrOfkitsActuators;
            
            var lightsKit = 0, lightOpt = 0;
            var engineKit = 0, engineOpt = 0;

            // coverage required actuators
            while (requirements > 0) {
              
              if (nrOfActuatorLights > (lightsKit + lightOpt)) {
                if (nrOfAvailablekitsActuators >0){
                  lightsKit = lightsKit + 1;
                  nrOfAvailablekitsActuators = nrOfAvailablekitsActuators - 1;
                } else{
                  lightOpt = lightOpt + 1;
                }
                requirements = requirements -1;
              }

              if (nrOfActuatorShutters > (engineKit + engineOpt)) {
                if (nrOfAvailablekitsActuators >0){
                  engineKit = engineKit + 1;
                  nrOfAvailablekitsActuators = nrOfAvailablekitsActuators - 1;
                } else{
                  engineOpt = engineOpt + 1;
                }
                requirements = requirements -1;
              }
            }

            // adding remains actuators 
            while (nrOfAvailablekitsActuators > 0) {
              if (nrOfAvailablekitsActuators >0){
                lightsKit = lightsKit + 1;
                nrOfAvailablekitsActuators = nrOfAvailablekitsActuators - 1;
              }

              if (nrOfAvailablekitsActuators >0){
                  engineKit = engineKit + 1;
                  nrOfAvailablekitsActuators = nrOfAvailablekitsActuators - 1;
                }
            }

            var nrOfCommandsToAdd          = this.model.get('nrOfCommands') - this.model.get('minNrOfCommands');
            
            window.BticinoS4B.eventAggregator.trigger("lightPoints:addAdditionalActuatorsToKit", lightsKit, lightOpt, nrOfLights);
            window.BticinoS4B.eventAggregator.trigger("engines:addAdditionalActuatorsToKit", engineKit, engineOpt);
            window.BticinoS4B.eventAggregator.trigger("commandPoints:addAdditionalActuatorsToKit", nrOfCommandsToAdd);

            this.model.set('updateAutocalculatedElements', false);
            this.model.set('actuatorsConfigurated', true);
            //alert('Aggiornamento avvenuto con successo');
          }
        },

        customizeKeycapsEventHandler: function() {
          console.log('customizeKeycapsEventHandler');
        },

        goToDevicesEventHandler: function(e) {
          var requestedZoneNumber = parseInt(e.target.id, 10);
          window.BticinoS4B.eventAggregator.trigger("zone:selectionRequested", requestedZoneNumber);
          window.BticinoS4B.eventAggregator.trigger("zoneStep:show");
        },

        spinnerEventHandler: function(e) {
          var className = e.target.className,
              idValue   = e.target.id,
              newValue,
              canModified;

          if (this.model.get('actuatorsConfigurated')) {
            if (confirm('Modificando le scelte iniziali verranno cancellati gli attuatori e i comandi aggiunti manualmente. Procedere?')) {
                    canModified = true;
                    this.model.set('updateAutocalculatedElements', true);
                    this.model.set('actuatorsConfigurated', false);
                } else {
                    canModified = false;
                }
          } else {
            canModified = true;
            this.model.set('updateAutocalculatedElements', true);
          }
            
          if (canModified && (idValue == 'lights')){
            if (className.indexOf('-up') > -1) {
              newValue = this.model.IncrementNrOfLights();
            } else {
              newValue = this.model.DecrementNrOfLights();
            }
            $(this.$el.find("input[name='numberOfLight']")[0]).val(newValue);
          } else if (canModified && (idValue == 'rollingShutters')){
            if (className.indexOf('-up') > -1) {
              newValue = this.model.IncrementNrOfRollingShutters();
            } else {
              newValue = this.model.DecrementNrOfRollingShutters();
            }
            $(this.$el.find("input[name='numberOfShutters']")[0]).val(newValue);
          } else if (canModified && (idValue == 'commands')){
            if (className.indexOf('-up') > -1) {
              newValue = this.model.IncrementNrOfCommands();
            } else {
              newValue = this.model.DecrementNrOfCommands();
            }
            $(this.$el.find("input[name='numberOfCommand']")[0]).val(newValue);
          }
         
          this.model.calculateNrOfAddress();
          this.showWariningText();
        },

        changeTemplate: function(templatePath) {
          this.template = templatePath;
        },

        addConstructor                  : function() {
          this.kitView = kitView;
        },

        initialize                      : function() {
          this.addConstructor();
          this.model.bind("render:requested", this.render,                  this);
          window.BticinoS4B.eventAggregator.unbind("addAdditionalElementsToKit", this.addElementToKitEventHandler);
          window.BticinoS4B.eventAggregator.bind("addAdditionalElementsToKit", this.addElementToKitEventHandler, this);
        },

        serialize                       : function() {
          return {model : this.model, app : app};
        },

        beforeRender                    : function() {
          var fetchedKits = this.model.get("fetchedKits");

          fetchedKits = _.filter(fetchedKits, function(iterableKit){return (_.contains(iterableKit.get("specialVars").referenceAccessoryLines, BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) || !iterableKit.get("specialVars").referenceAccessoryLines);});

          for (var i = 0, length = fetchedKits ? fetchedKits.length : 0; i < length; i++)
          {
            this.insertView(".kits", new this.kitView({model : fetchedKits[i]}));
          }
        },

        overImageDetails : function(){
            var productDisplay="";
            $('.boxMouseover','#mouseoverImage').mouseover(function(){
                productDisplay=$(this).attr('product');
                $('#'+productDisplay).css('display','block');
            }).mouseout(function(){
                $('.productDetail','#productDetails').css('display','none');
            });
        },
        
        afterRender                     : function() {
          var kitTmp=BticinoS4B.Instances.Models.ApplicationModel.get("kitCode");
          this.overImageDetails();
          //console.log(this);
          if(!kitTmp)
            this.$el.hide();
          else{
            var fetchedKits = this.model.get("fetchedKits");

            fetchedKits = _.filter(fetchedKits, function(iterableKit){return (_.contains(iterableKit.get("specialVars").referenceAccessoryLines, BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) || !iterableKit.get("specialVars").referenceAccessoryLines);});

            window.customizeFormElements();
            

            if (fetchedKits.length===0)
              this.$el.find(".noItemsSection").show();
            else
              this.$el.find(".noItemsSection").hide();
          }
        }
      })
    },

    Model: genericElement.Model.extend({
      defaults: {
        enabled             : false,
        fetchedKits         : [],
        quantity            : 1,
        collection          : []
      },

      addConstructor                    : function() {
        this.kitModel = kitModel;
      },

      initialize                        : function() {
        this.addConstructor();
        var that    = this;

        //Bind on accessory line selection
        window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen',  this.accessoryLineChosenEventHandler);
        window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen',    this.accessoryLineChosenEventHandler, this);

        //Bind on accessory line removal
        window.BticinoS4B.eventAggregator.unbind('accessoryLine:removed', this.accessoryLineRemovedEventHandler);
        window.BticinoS4B.eventAggregator.bind('accessoryLine:removed',   this.accessoryLineRemovedEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("load:Project",          this.loadProject);
        window.BticinoS4B.eventAggregator.bind("load:Project",            this.loadProject, this);

        this.bind("packages:fetched",                       this.packagesFetchedEventHandler, this);
        this.bind("products:fetched",                       this.kitChosenEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",  this.deliverModel);
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",    this.deliverModel, this);

        this.bind("change:packageClassId", this.packageClassIdChangedEventHandler);

        //Check if there's a preconfigured kit
        
        if(that.get("wizardChoiceId"))
          this.accessoryLineChosenEventHandler();
      },

      findValueFromProductCode : function(productCode) {
        var dictionary = this.get("dictionary");

        var values = _.filter(dictionary, function(iterableValue){
          return iterableValue.productCode===productCode;
        });

        if (values.length===1)
          return values[0];
        else
          return false;
      },

      accessoryLineChosenEventHandler   : function() {
        this.fetchKits();
      },

      packagesFetchedEventHandler       : function() {
        this.trigger("render:requested");
      },

      packageClassIdChangedEventHandler : function() {
        var fetchedKits       = this.get("fetchedKits");
        this.fetchProducts(this.get("packageClassId"));

        for (var i = fetchedKits.length - 1; i >= 0; i--) {
          this.fetchComponentsPackages(fetchedKits[i]);
        }
      },

      kitChosenEventHandler             : function() {
        this.trigger("render:requested");
      },

      fetchKits                         : function() {
        var that            = this;
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(that.get("wizardChoiceId"), function(data){
          that.kitsFetchedEventHandler.apply(that, [data]);
        }, true, 0);
        this.trigger("packages:fetching");
      },

      addCurrentKit                     : function() {

      },

      removeCurrentKit                  : function() {
        this.set("added", false);
        window.BticinoS4B.eventAggregator.trigger("removeKitItems", this.get("packageClassId"));
      },

      kitsFetchedEventHandler           : function(data) {
        var i=0,
            length = 0,
            kits = data.packages;

        for (i = 0, length = kits.length; i < length; i++)
        {
          if (kits[i].specialVars && kits[i].specialVars.constructor === String)
            kits[i].specialVars = JSON.parse(kits[i].specialVars);

          kits[i] = new this.kitModel(kits[i]);
        }
        
        if (BticinoS4B.Instances.Models.ApplicationModel.get("kitCode")){
            var code = BticinoS4B.Instances.Models.ApplicationModel.get("kitCode");
            var tmpPackageClassId;

            switch(code) {
                case 'MHKIT1013':
                    tmpPackageClassId = '22100';
                    break;
                case 'MHKIT4013':
                    tmpPackageClassId = '22101';
                    break;
                case 'MHKIT1114':
                    tmpPackageClassId = '1623';
                    break;
            }

            var tmpKits = _.filter(kits, function(kit) {
              return (kit.get('packageClassId') === tmpPackageClassId);
            });

            if (tmpKits) {
              kits = tmpKits;
            }
        }


        this.set("fetchedKits", kits);

        this.trigger("packages:fetched");
      },

      reactivateConnection            : function() {
        window.BticinoS4B.eventAggregator.trigger("reactivateKitConnection");
      },

      deliverModel                    : function() {
        var kits = [],
            dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            fetchedKits  = this.get("fetchedKits"),
            i=0, j=0, length=0;

        for (i = 0, length = fetchedKits ? fetchedKits.length : 0; i < length; i++)
        {
          if (fetchedKits[i].get("added"))
          {
            dataProvider.addItems("externalItems", {
              productCode       : fetchedKits[i].get("productCode"),
              productLabel      : fetchedKits[i].get("productLabel"),
              packageClassId    : fetchedKits[i].get("packageClassId"),
              packageClassLabel : fetchedKits[i].get("packageClassLabel"),
              quantity          : 1,
              price             : fetchedKits[i].get("price")
            });

            if ((fetchedKits[i].get("secondaryProducts"))&&(fetchedKits[i].get("secondaryProducts").length>0))
            {
              for (j=0; j<fetchedKits[i].get("secondaryProducts").length; j++) {
                dataProvider.addItems("externalItems", {
                  productCode       : fetchedKits[i].get("secondaryProducts")[j].productCode,
                  productLabel      : fetchedKits[i].get("secondaryProducts")[j].productLabel,
                  packageClassLabel : fetchedKits[i].get("secondaryProducts")[j].packageClassLabel,
                  kitValue          : fetchedKits[i].get("kitValue"),
                  partOfKit         : fetchedKits[i].get("partOfKit"),
                  quantity          : 1,
                  price             : fetchedKits[i].get("secondaryProducts")[j].price
                });
              }
            }
          }
        }

          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.kits = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.kits = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.kits = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.kits = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.kits = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.kits = this;
              break;
          }
        
        BticinoS4B.Instances.Models.ApplicationModel.set("kits", this);
      },

      loadProject   : function(model) {
        var that                = this,

        loadData            = function() {
          var i                   = 0,
              length              = 0,
              fetchedKits         = that.get("fetchedKits"),
              retrieveCorrectKit  = function(iterableKit){
                return model.kitsModel.collection[i].packageClassId===iterableKit.get("packageClassId");
              };

          if(model.kitsModel && model.kitsModel.collection.length>0)
          {
            for (i = 0, length = model.kitsModel.collection.length; i < length; i++) {
              if(fetchedKits.length>0)
                _.filter(fetchedKits, retrieveCorrectKit)[0].addKit(true);
            }
          }
          that.unbind("change:fetchedKits", loadData);
          that.trigger("render:requested");
        };

        if (this.get("fetchedKits"))
          loadData();
        else
          this.bind("change:fetchedKits", loadData, this);
      }
    }),

    KitModel : kitModel
  });

  // Required, return the module for AMD compliance
  return kits;
});